const Config = {
    apiUrl: "https://api.moneymanager.com.ua"
}

export default Config;